export const FORM_KEYS = Object.freeze({
    DAYS_IDS: "daysIds",
    TIME_START: "timeStart",
    TIME_END: "timeEnd"
});
export const FORM_ERROR_KEYS = {
    SCHEDULE: "schedule",
};
export const INIT_FORM = {
    [FORM_KEYS.DAYS_IDS]: [],
    [FORM_KEYS.TIME_START]: -1,
    [FORM_KEYS.TIME_END]: -1
};
export const SCHEDULE_FIELDS_KEYS = [FORM_KEYS.TIME_START, FORM_KEYS.TIME_END];
export const INIT_FORM_ERROR = {
    [FORM_ERROR_KEYS.SCHEDULE]: null
};